// extracted by mini-css-extract-plugin
export default {"container":"JsonEditor__container___fpwSk"};